import * as React from 'react';
import * as styles from './YandexIcon.scss';

export default (props: any) => (
  <img
    className={styles.yandexLogo}
    src="https://www.wix.com/_partials/third-party/cashier-settings/methods-new/method-icon-yandex-new.svg"
    style={props.style}
  />
);



// WEBPACK FOOTER //
// ./components/icons/YandexIcon/YandexIcon.tsx